import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { CommonInput, SelectInput } from 'sharedComponents/inputGroup';
import { formRequiredRules } from 'helper';
import { errorMessage } from 'constants/CommonConstants';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { calculatePaymentsParams } from 'pages/digitalRetailing/DigitalRetailingInterface';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { debounce } from 'lodash';
import { calculatePayments } from 'store/DigitalRetailingState';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { TERM } from 'pages/digitalRetailing/DigitalRetailingConstant';
import { formatWithCommaSeparator } from 'pages/tradeIn/TradeInUtils';

interface FinancePaymentViewProps {
  selectedPaymentData?: calculatePaymentsParams; // Replace 'any' with the appropriate type
}

const FinancePaymentView: React.FC<FinancePaymentViewProps> = () => {
  // console.log('selectedPaymentData', selectedPaymentData);
  const { t } = useTranslation();

  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { control, trigger, watch } = useFormContext();

  const downPaymentWatcher = watch('downPayment');
  const termWatcher = watch('term');

  const { authenticateClientData } = useSelector((state: RootState) => state.auth);
  const { vehicleData, paymentData } = useSelector((state: RootState) => state.digitalRetailingStore);

  const term = authenticateClientData?.data?.widgetData?.term;
  const apr = authenticateClientData?.data?.widgetData?.apr;

  const debouncedCalculatePayments = debounce((downPaymentWatcher, term, apr, vehicleData, dispatch) => {
    dispatch(
      calculatePayments({ requestParams: { downpayment: downPaymentWatcher, term, apr, financed: vehicleData?.MSR } })
    );
  }, 500);

  useEffect(() => {
    downPaymentWatcher &&
      debouncedCalculatePayments(downPaymentWatcher, termWatcher || term, apr, vehicleData, dispatch);
    return () => {
      debouncedCalculatePayments.cancel();
    };
  }, [downPaymentWatcher, term, apr, vehicleData, termWatcher, dispatch]);

  return (
    <>
      <div className='dr-payment-tile__vwl mb-4'>
        <div className='dr-payment-tile__vwl__lbl'>Finance</div>
        <div className='dr-payment-tile__vwl__value-wrapper'>
          <div className='dr-payment-tile__vwl__value xl fw-500'>{`$${paymentData?.monthly?.toFixed(2)}`}</div>
          <span className='fw-400 text-secondary'>{`x ${termWatcher || term} months`}</span>
        </div>
      </div>
      <Grid container spacing={2} marginBottom={3}>
        <Grid item md={4}>
          <CommonInput
            name='downPayment'
            control={control}
            label={t('digitalRetailing.downPayment')}
            placeholder={t('digitalRetailing.downPayment')}
            type='number'
            triggerValidationForField={trigger}
            rules={formRequiredRules(errorMessage(t).required)}
          />
        </Grid>
        <Grid item md={4}>
          <SelectInput
            name='term'
            control={control}
            label={t('Term')}
            options={TERM}
            triggerValidationForField={trigger}
            defaultValue={termWatcher}
          />
        </Grid>
      </Grid>
      <ul className='dr-amt-summary list-unstyled mb-0'>
        <li>
          <div className='dr-amt-summary__lbl'>APR</div>
          <div className='dr-amt-summary__value'>{`${apr}%`}</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>MSRP</div>
          <div className='dr-amt-summary__value'>{`$${formatWithCommaSeparator(vehicleData?.MSR)}`}</div>
        </li>
        {/* <li>
          <div className='dr-amt-summary__lbl'>Price Adjustment</div>
          <div className='dr-amt-summary__value'>+ $6.921.00</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Internet Price</div>
          <div className='dr-amt-summary__value'>$56,100</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Final Vehicle Price</div>
          <div className='dr-amt-summary__value'>$56,100</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Trade In (Net)</div>
          <div className='dr-amt-summary__value'>N/A</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Total Fees</div>
          <div className='dr-amt-summary__value'>$0.00</div>
        </li> */}
      </ul>
    </>
  );
};

export default FinancePaymentView;
